import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GetEmpty } from 'src/app/classes/Empties';
import { FacturaMetaData } from 'src/app/classes/FacturaMetaData';
import { BaseComponent } from 'src/app/pages/base/base.component';

@Component({
	selector: 'app-satxmlviewer',
	templateUrl: './satxmlviewer.component.html',
	styleUrls: ['./satxmlviewer.component.css']
})
export class SatxmlviewerComponent extends BaseComponent implements OnInit, OnChanges
{
	@Input() xml_attachment_id:number | null = null;
    factura_metadata: FacturaMetaData = new FacturaMetaData('');
    error: string = '';

	ngOnInit(): void
	{

	}
	ngOnChanges(changes: SimpleChanges): void
	{
		if( changes.xml_attachment_id.currentValue && changes.xml_attachment_id.previousValue != changes.xml_attachment_id.currentValue )
		{
			let url = this.rest.getFilePath(changes.xml_attachment_id.currentValue,false);
			this.is_loading = true;

			fetch(url)
			.then(response => response.text())
			.then(data =>
			{
				this.factura_metadata = new FacturaMetaData(data);
				this.is_loading = false;
			})
			.catch(error=>
			{
				console.error('Error al cargar el archivo xml',error);
				this.error = 'Ocurrio un error al cargar el archivo xml';
			});

		}
	}
}
